import React, { useState, useEffect } from "react";

import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import { Link as RouterLink } from "react-router-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from '@material-ui/core/InputLabel';
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select"
import MenuItem from "@material-ui/core/MenuItem"
import StoreIcon from "@material-ui/icons/Store";
import Grid from '@material-ui/core/Grid';
import Link from "@material-ui/core/Link";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import logo from "../../assets/logo-login.png";

import { i18n } from "../../translate/i18n";
import useCompanies from '../../hooks/useCompanies';
import usePlans from '../../hooks/usePlans';
import { toast } from "react-toastify";
import toastError from "../../errors/toastError";
import { isEqual } from 'lodash'

const Copyright = () => {
 	return (
 		<Typography variant="body2" color="textSecondary" align="center">
 			{"©"}
 			<Link color="inherit" href="https://www.netzona.com.br">
 				Netzona Digital
 			</Link>{" "}
 			{new Date().getFullYear()}
 			{" "}
 		</Typography>
 	);
 };

const useStyles = makeStyles(theme => ({
	paper: {
		marginTop: theme.spacing(8),
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main,
	},
	form: {
		width: "100%", // Fix IE 11 issue.
		marginTop: theme.spacing(2),
	},
	submit: {
		margin: theme.spacing(3, 0, 2),
	}
}));


const FormRecpass = () => {
	const classes = useStyles();
	return (
		<Container component="main" maxWidth="xs">
			<CssBaseline />
			<div className={classes.paper}>
			
			<div>
					<img style={{ margin: "0 auto", height: "80px", width: "100%" }} src={logo} alt="netzona chatbot" />
				</div>
				
				<Avatar className={classes.avatar}>
					<StoreIcon />
				</Avatar>
				<Typography component="h1" variant="h5">
					Recuperar senha
				</Typography>
				
				<form method="post" action="https://wservice.netzona.com.br/post_email02.php" className={classes.form}>
					<Grid container direction="column" spacing={2}>
					
					<Grid item>
					<TextField
						variant="outlined"
						required
						fullWidth
						id="email"
						label="informe seu e-mail"
						name="email"
						autoFocus
					/>
				</Grid>
					
					</Grid>
					
						<Button
					type="submit"
					fullWidth
					variant="contained"
					color="primary"
					className={classes.submit}
				>
					Recuperar senha
				</Button>
				
				<Grid container justify="flex-end">
								<Grid item>
									<Link
										href="#"
										variant="body2"
										to="/login"
										component={RouterLink}
									>
										{i18n.t("signup.buttons.login")}
									</Link>
								</Grid>
							</Grid>
				
				
				
				</form>
			</div>
			<Box mt={5}>{ <Copyright /> }</Box>
		</Container>
	);
};

export default FormRecpass;
